export const ERROR_NOT_FOUND = 'Not found';
export const ERROR_ACCESS_FORBIDDEN = 'Access Forbidden';
export const ERROR_CODE_CSRF = 'EBADCSRFTOKEN';
export const ERROR_NOT_AUTHORIZED = 'Not authorized';
export const ERROR_NOT_AUTHENTICATED = 'Not authenticated';
export const ERROR_TOKEN_EXPIRED = 'Token expired';
export const ERROR_UNKNOWN = 'An error occurred while processing your request. Please try again later.';
